import { Injectable } from '@angular/core';
import moment from 'moment';
import 'moment/locale/es-mx';

moment.locale('es-mx');
moment.updateLocale('es-mx', {

  calendar: {
    sameDay: '[Hoy]',
    nextDay: '[Mañana]',
    nextWeek: 'dddd',
    lastDay: '[Ayer]',
    lastWeek: '[El] dddd [pasado]',
    sameElse: 'DD MMM YYYY'
  }
});

@Injectable({
  providedIn: 'root'
})
export class MomentService {
  moment:typeof moment = moment;
}